export default {
  data() {
    return {
      width: window.innerWidth,
    }
  },
  created() {
    this.$nextTick(() => {
      // Change width
      window.addEventListener('resize', () => {
        this.width = window.innerWidth
      })
    })
  },
}
